import axios from 'axios';
import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

// Searchspring Cookies - Refer to https://docs.searchspring.com/reference/searchspring-cookies
const userIdKey = 'ssUserId';
const intelliSuggestKey = '_isuid';
const sessionKey = 'ssSessionIdNamespace';

// const SITE_ID = 'f4sjfr';
const SITE_ID = window.searchspringConfig.siteId;
const SEARCHSPRING_API_SEARCH_URL = `https://${SITE_ID}.a.searchspring.io/api/search/search.json`;
const SEARCHSPRING_AUTOCOMPLETE_API_URL = `https://${SITE_ID}.a.searchspring.io/api/search/autocomplete.json`;
const SEARCHSPRING_SUGGEST_API_URL = `https://${SITE_ID}.a.searchspring.io/api/suggest/query`;
const SEARCHSPRING_TRENDING_API_URL =`https://${SITE_ID}.a.searchspring.io/api/suggest/trending`;
const SEARCHSPRING_RECS_API_URL = `https://${SITE_ID}.a.searchspring.io/boost/${SITE_ID}/recommend`;


export function getSearchspringUUIDs() {
  let userId = Cookies.get(userIdKey);
  let intelliSuggestId = Cookies.get(intelliSuggestKey);
  let sessionId = Cookies.get(sessionKey);
  // New ID on every page load
  let pageLoadId = uuidv4();

  // ssUserId and _isuid should match and expire in 1 year
  if (!userId || !intelliSuggestId || userId !== intelliSuggestId) {
    const sharedUUID = uuidv4();

    userId = sharedUUID;
    intelliSuggestId = sharedUUID;

    Cookies.set(userIdKey, sharedUUID, { expires: 365 });
    Cookies.set(intelliSuggestKey, sharedUUID, { expires: 365 });
  }

  // ssSessionIdNamespace should expire when session ends
  if (!sessionId) {
    const uuid = uuidv4();

    Cookies.set(sessionKey, uuid);
  }

  return {
    userId,
    sessionId,
    pageLoadId
  };
}

export const getCommonParams = () => ({
  ...getSearchspringUUIDs(),
  domain: Shopify.shop,
  redirectResponse: 'minimal',
  resultsFormat: 'json',
  siteId: SITE_ID,
});

export const fetchProductResults = async (query, filterQueryString="") => {
  try {
    const response = await axios.get(`${SEARCHSPRING_API_SEARCH_URL}?${filterQueryString}`, {
      params: {
        ...query,
        ...getCommonParams(),
      },
      headers: {
        'Accept': 'application/json',
      },
    });

    // Searchspring redirect - https://docs.searchspring.com/reference/standard-merchandising#redirects
    if (response.data?.merchandising?.redirect) {
      window.location.href = response.data?.merchandising.redirect;
      return;
    }

    return response.data;

  } catch (error) {
    console.error('Error fetching search results:', error);
    throw error;
  }
};

export const fetchAutocompleteResults = async (query) => {
  try {
    const response = await axios.get(SEARCHSPRING_AUTOCOMPLETE_API_URL, {
      params: {
        ...query,
        ...getCommonParams(),
      },
      headers: {
        'Accept': 'application/json',
      },
    });

    // Searchspring redirect - https://docs.searchspring.com/reference/standard-merchandising#redirects
    if (response.data?.merchandising?.redirect) {
      window.location.href = response.data?.merchandising.redirect;
      return;
    }

    return response.data;

  } catch (error) {
    console.error('Error fetching autocomplete results:', error);
    throw error;
  }
};

export const fetchSuggestResults = async (query) => {
  try {
    const response = await axios.get(SEARCHSPRING_SUGGEST_API_URL, {
      params: {
        ...query,
        ...getCommonParams(),
      },
      headers: {
        'Accept': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching suggest results:', error);
    throw error;
  }
};

export const fetchTrendingResults = async () => {
  try {
    const response = await axios.get(SEARCHSPRING_TRENDING_API_URL, {
      params: {
        ...getCommonParams(),
      },
      headers: {
        'Accept': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching trending results:', error);
    throw error;
  }
};

export const fetchRecommendationResults = async (productId, tags) => {
  try {
    const response = await axios.get(SEARCHSPRING_RECS_API_URL, {
      params: {
        product: productId,
        tags,
        ...getCommonParams(),
      },
      headers: {
        'Accept': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching trending results:', error);
    throw error;
  }
}

// Tracking
export function trackProductClicks(intellisuggestData, intellisuggestSignature) {
  if (!window.IntelliSuggest) return;

  window.IntelliSuggest.clickItem(this, {
    siteId: SITE_ID,
    intellisuggestData,
    intellisuggestSignature
  });
}
